import { Diamond } from "lucide-react";

const items = [
  "NPL", "UTP", "Servicing", "Due Diligence", "Asset Management",
  "Recupero Crediti", "Trading di Portafogli", "Possessing Immobiliare",
];

const Marquee = () => (
  <div data-testid="editorial-marquee" className="overflow-hidden border-y border-gold/15 bg-navy-deep py-5">
    <div className="animate-marquee flex w-max items-center gap-10">
      {[...items, ...items].map((item, i) => (
        <span key={i} className="flex items-center gap-10 whitespace-nowrap text-sm font-semibold uppercase tracking-[0.35em] text-gold/60">
          {item}
          <Diamond size={9} className="fill-gold/30 text-gold/30" />
        </span>
      ))}
    </div>
  </div>
);

export default Marquee;
